export const MigrationConstants = {
  UPLOAD_USER_REQUEST: "UPLOAD_USER_REQUEST",
  UPLOAD_USER_SUCCESS: "UPLOAD_USER_SUCCESS",
  UPLOAD_USER_FAILURE: "UPLOAD_USER_FAILURE",
};
